export const REACT_APP_API_BASE_URL = process.env.REACT_APP_BASE_API_URL;
export const REACT_APP_MAP_BOX_ACCESS_KEY = process.env.REACT_APP_MAP_BOX_ACCESS_KEY;
export const REACT_APP_GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
export const REACT_PUBLIC_ASSEMBLYAI_API_KEY = "7be249da2b9a42c3afc6ceb54be966cf";
export const REACT_PUBLIC_OPENAI_API_KEY = "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";
export const DEFAULT_DATE = "1971-01-01";
export const DEFAULT_TABLE_ROWS = 10;
